module.exports = __webpack_public_path__ + "static/media/sign-out-icon-blue.57484f24.svg";